import { Injectable } from '@angular/core';
import { UtilService } from '../../shared/services/util.service';
import { FormControl, FormArray } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TimeValidationService {
  cutoffTime: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  constructor(private utilService: UtilService) { }

  pickupTimeValidator(dateControl: FormControl, cutOff: string|number, timeControl: FormControl) {
    cutOff = Number(cutOff);
    this.cutoffTime.next(cutOff);
    if (timeControl.value && dateControl.value) {
      for (const date of dateControl.value) {
        const dateTimeString = this.utilService.convertMomentToDateString(date) +  ' ' + timeControl.value;
        const bookingTime = this.utilService.getMoment(dateTimeString, 'DD/MM/YYYY hh:mm A');
        if (this.utilService.findTimeDiffInMinutes(bookingTime) < cutOff) {
          timeControl.markAsDirty();
          return {
            // tslint:disable-next-line: max-line-length
            pickupCutoff: `Booking must be ${Math.floor(cutOff / 60) > 0 ? Math.floor(cutOff / 60) + ' hours' : ''} ${cutOff % 60 > 0 ?  cutOff % 60 + ' minutes' : ''} away`
          };
        }
      }
    }
    return null;
  }

  stopTimeValidator(stops: FormArray) {
    if (stops.length > 1) {
      const timeCheck: any[] = [];
      const startTimePicker = stops.at(0).get('time');
      if (startTimePicker.value) {
        timeCheck.push({
          time: this.utilService.convert12HrTimeToMilitaryTime(startTimePicker.value)
        });
      }
      for (let stopIndex = 1; stopIndex < stops.length; stopIndex++) {
        const stop = stops.at(stopIndex);
        const timePicker = stop.get('time');
        if (timePicker && timePicker.value) {
          const militaryTime = this.utilService.convert12HrTimeToMilitaryTime(timePicker.value);
          let dayChangePoint = false;
          if (timeCheck.length) {
            for (let timeIndex = timeCheck.length - 1; timeIndex >= 0; timeIndex--) {
              if ( militaryTime <= timeCheck[timeIndex].time ) {
                // check if time is from next day
                if (timeCheck[timeIndex].time >= 1200 && militaryTime < 1200) {
                  dayChangePoint = true;
                  if (timePicker.errors) {
                    const errors = this.utilService.deepCopy(timePicker.errors);
                    delete timePicker.errors.order;
                    timePicker.setErrors(Object.keys(errors).length ? errors : null);
                  }
                  break;
                } else {
                  timePicker.setErrors({order: 'Stop scheduled before previous stop'});
                  timePicker.markAsDirty();
                  break;
                }
              } else if (timeCheck[timeIndex].dayChangePoint) {
                break;
              }
            }
          }
          timeCheck.push({
            time: militaryTime
          });
        }
      }
    }
  }

  convertDateObjTimeStrToMoment(date, time) {
    return this.utilService.getMoment(`${date.value[0].format('DD/MM/YYYY')} ${time.value}`, 'DD/MM/YYYY hh:mm A');
  }

  mergeStopTimeValidator = (stops: FormArray) => {
    const timeCheck = [this.convertDateObjTimeStrToMoment(stops.at(0).get('date'), stops.at(0).get('time'))];
    for (let stopIndex = 1; stopIndex < stops.length; stopIndex++) {
      const timePicker = stops.at(stopIndex).get('time');
      if (timePicker.value && timeCheck.length) {
        const stopTime = this.convertDateObjTimeStrToMoment(stops.at(stopIndex).get('date'), timePicker);
        if (timeCheck[timeCheck.length - 1].isAfter(stopTime) || timeCheck[timeCheck.length - 1].isSame(stopTime)) {
          timePicker.setErrors({order: 'Stop scheduled before previous stop'});
          timePicker.markAsDirty();
        } else if (timePicker.errors) {
            const errors = this.utilService.deepCopy(timePicker.errors);
            delete timePicker.errors.order;
            timePicker.setErrors(Object.keys(errors).length ? errors : null);
        }
        timeCheck.push(stopTime);
      }
    }
  }

}
